<p-dialog
  [visible]="visible"
  (visibleChange)="setVisible($event)"
  [header]="header | translate"
  styleClass="p-dialog-large"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  [blockScroll]="true"
  [closeOnEscape]="true"
  closeIcon="fa fa-times"
  appendTo="body"
>
  <h1>{{ confirm | translate }}</h1>
  <ng-content></ng-content>
  <p-footer>
    <div class="p-actions-bar">
      <button type="button" pButton [icon]="acceptIcon" [label]="acceptLabel | translate" (click)="accept()"></button>
      <button
        type="button"
        pButton
        [icon]="rejectIcon"
        [label]="rejectLabel | translate"
        (click)="reject()"
        class="p-button-secondary"
      ></button>
    </div>
  </p-footer>
</p-dialog>
<button
  pButton
  type="button"
  (click)="open($event)"
  [icon]="icon"
  [disabled]="disabled"
  [label]="iconOnly ? '' : (label | translate)"
  class="p-button-danger p-button-outlined"
  [ngClass]="buttonNgClass"
  type="button"
></button>
